module.exports = __webpack_public_path__ + "img/image12.42f0fd55.png";